'use strict';

angular.module('ntmApp').factory('ListGridMultiselect', function () {

    function ListGridMultiselect(settings) {

        var self = this;

        settings = settings || {enable: false, selectAll: false};

        self.isEnable = function () {
            return settings.enable;
        };

        self.selectAll = function () {
            return settings.enable && settings.selectAll;
        };

    }

    return (ListGridMultiselect);
});